import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import base_url from './api/Config';

const Login = () => {
    const [mobileNo, setMobileNo] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (Cookies.get('authToken')) navigate('/Home');
    }, [navigate]);

    const allowOnlyNumbers = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await fetch(`${base_url}/api/admin/loginDashboard`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ adminId: mobileNo, adminPassword: password }),
            });

            const text = await res.text();
            let body;
            try { body = JSON.parse(text); } catch { body = text; }

            if (res.ok) {
                const token = body.token || body?.data?.token;
                if (token) {
                    Cookies.set("authToken", token, { expires: 1 / 24 }); // 1 ghanta
                    localStorage.setItem("adminId", mobileNo);
                    localStorage.setItem("fintechId", body.fintechId || mobileNo);
                    navigate("/Home");
                } else {
                    alert("Login succeeded but token missing");
                }
            } else {
                alert("Invalid credentials. Please try again.");
            }
        } catch (err) {
            alert("Network error. Please check your connection.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                {/* Header */}
                <div style={styles.header}>
                    <img
                        src="/assets/images/Logo.png"
                        alt="Ujjwal Srijan"
                        style={styles.logo}
                        onError={(e) => { e.target.style.display = 'none'; }}
                    />
                    <h1 style={styles.brandName}>Ujjwal Srijan</h1>
                    <p style={styles.tagline}>Loan Management Portal</p>
                </div>

                {/* Form */}
                <div style={styles.formSection}>
                    <h5 style={styles.welcomeText}>Welcome Back</h5>
                    <p style={styles.subText}>Sign in to your account</p>

                    <form onSubmit={handleFormSubmit}>
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Mobile Number <span style={styles.star}>*</span></label>
                            <input
                                type="tel"
                                style={styles.input}
                                maxLength={10}
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                                onKeyPress={allowOnlyNumbers}
                                placeholder="Enter mobile number"
                                required
                            />
                        </div>

                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Password <span style={styles.star}>*</span></label>
                            <input
                                type="password"
                                style={styles.input}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter password"
                                required
                            />
                        </div>

                        <button type="submit" style={styles.loginBtn} disabled={loading}>
                            {loading ? 'Signing in...' : 'Login'}
                        </button>
                    </form>
                </div>

                {/* Footer */}
                <div style={styles.footer}>
                    <p style={styles.footerText}>Ujjwal Srijan Finance Pvt. Ltd.</p>
                </div>
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1d2e77 0%, #0a1540 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
    },
    card: {
        background: '#fff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '420px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        overflow: 'hidden',
    },
    header: {
        background: 'linear-gradient(135deg, #1d2e77 0%, #2a3f99 100%)',
        padding: '32px 24px 28px',
        textAlign: 'center',
    },
    logo: {
        height: '60px',
        width: 'auto',
        objectFit: 'contain',
        marginBottom: '12px',
    },
    brandName: {
        color: '#11c232',
        fontSize: '26px',
        fontWeight: '700',
        margin: '0 0 4px 0',
        letterSpacing: '0.5px',
    },
    tagline: {
        color: 'rgba(255,255,255,0.75)',
        fontSize: '13px',
        margin: '0',
        fontWeight: '400',
    },
    formSection: {
        padding: '28px 28px 20px',
    },
    welcomeText: {
        color: '#1d2e77',
        fontWeight: '700',
        fontSize: '20px',
        marginBottom: '4px',
    },
    subText: {
        color: '#888',
        fontSize: '13px',
        marginBottom: '24px',
    },
    fieldGroup: {
        marginBottom: '18px',
    },
    label: {
        display: 'block',
        fontWeight: '600',
        fontSize: '14px',
        color: '#333',
        marginBottom: '6px',
    },
    star: {
        color: '#e53935',
    },
    input: {
        width: '100%',
        height: '50px',
        borderRadius: '8px',
        border: '1.5px solid #ddd',
        padding: '0 14px',
        fontSize: '16px',
        outline: 'none',
        transition: 'border-color 0.2s',
        boxSizing: 'border-box',
        color: '#333',
    },
    loginBtn: {
        width: '100%',
        height: '52px',
        background: 'linear-gradient(135deg, #11c232 0%, #0da02a 100%)',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '17px',
        fontWeight: '700',
        cursor: 'pointer',
        marginTop: '8px',
        letterSpacing: '0.5px',
        transition: 'opacity 0.2s',
    },
    footer: {
        borderTop: '1px solid #f0f0f0',
        padding: '14px',
        textAlign: 'center',
        background: '#fafafa',
    },
    footerText: {
        color: '#aaa',
        fontSize: '12px',
        margin: '0',
    },
};

export default Login;
